import extenso from 'extenso';

export const porExtenso = (value, mode = 'currency') =>
  `${extenso(value ? value.toFixed(2).replace('.', ',') : '0', { mode })}`;
